import React, { useEffect } from 'react';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import {
  ReactPlugin,
  useAppInsightsContext,
  useTrackMetric,
} from '@microsoft/applicationinsights-react-js';
import Constants from '../../common/constants/Constants';

const messagetypeToAISeverityLeveL = (messageType) => {
  switch (messageType) {
    case 'error': {
      return SeverityLevel.Error;
    }
    case 'success': {
      return SeverityLevel.Information;
    }
    case 'info': {
      return SeverityLevel.Information;
    }
    case 'warning': {
      return SeverityLevel.Warning;
    }
    default: {
      return SeverityLevel.Information;
    }
  }
};

export const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
  config: {
    connectionString: Constants.APPINSIGHTSKEY,
    disableExceptionTracking: false,
    extensions: [reactPlugin],
    extensionConfig: {},
    enableAutoRouteTracking: true,
  },
});
ai.loadAppInsights();

export const logToAppInsights = (source, message, severity) => {
  ai.appInsights.trackTrace({
    message: `${source} message: ${message}`,
    severityLevel: messagetypeToAISeverityLeveL(severity),
  });
};

export const withAppInsights = (Component) => {
  const Wrapper = (props) => {
    const appInsights = useAppInsightsContext();
    let componentName = props.pageName != undefined ? props.pageName : props.location.pathname;
    const trackComponent = useTrackMetric(appInsights, componentName);
    useEffect(() => {
      trackComponent();
    });
    return <Component {...props} />;
  };
  return Wrapper;
};
